var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mixed-chart"},[_c('VueApexCharts',{ref:"vchart",attrs:{"type":_vm.type,"height":_vm.chartHeight,"options":_vm.chartOptions,"series":_vm.downloadedSeries}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }